import React, { useRef } from 'react';
import { Row, Col, ImageBadge, Tile } from 'seduo-ui';
const Example = () => (<Row>
        <Col md={6}>
            <Tile href="#" title="Moric test kurz" lector="Pavel Moric" imageSrc="https://dummyimage.com/520x460/9fa4a8/fff.png" overlay={{ bottomLeft: <ImageBadge theme="dark" text="1h 55min"/> }} videoRef={useRef(null)} video={{
        src: 'https://lmc-vod.ssl.cdn.cra.cz/0143/9518/cze-hd2-s0U5SoTh.mp4',
        type: 'video/mp4',
        muted: true,
        autoplay: true,
        loop: true,
        pause: true,
    }} large={true}/>
        </Col>
        <Col>
            <Tile href="#" title="Moric test kurz" lector="Pavel Moric" imageSrc="https://dummyimage.com/520x350/9fa4a8/fff.png" overlay={{ bottomLeft: <ImageBadge theme="dark" text="1h 55min"/> }} videoRef={useRef(null)} video={{
        src: 'https://lmc-vod.ssl.cdn.cra.cz/0143/9518/cze-hd2-s0U5SoTh.mp4',
        type: 'video/mp4',
        muted: true,
        autoplay: true,
        loop: true,
        pause: true,
    }}/>
            <Tile href="#" title="Moric test kurz" lector="Pavel Moric" imageSrc="https://dummyimage.com/520x350/9fa4a8/fff.png" overlay={{ bottomLeft: <ImageBadge theme="dark" text="1h 55min"/> }} videoRef={useRef(null)} video={{
        src: 'https://lmc-vod.ssl.cdn.cra.cz/0143/9518/cze-hd2-s0U5SoTh.mp4',
        type: 'video/mp4',
        muted: true,
        autoplay: true,
        loop: true,
        pause: true,
    }}/>
        </Col>
    </Row>);
export default Example;
